import React, { FC } from "react";
import { KeywordsView } from "../components";

export const KeywordsPage: FC = () => {
  return <KeywordsView />;
};
